import { render, staticRenderFns } from "./Top100Labels.vue?vue&type=template&id=c56e3ddc"
import script from "./Top100Labels.vue?vue&type=script&lang=js"
export * from "./Top100Labels.vue?vue&type=script&lang=js"
import style0 from "./Top100Labels.vue?vue&type=style&index=0&id=c56e3ddc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_8ff5e82d1052802783b01bda34c69ff2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports